import { Component, OnInit } from '@angular/core';
import { WaterProcess } from 'src/app/domain/EAU/water-process';
import { WaterService } from 'src/app/services/water.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { MethodePrelevementEau } from 'src/app/domain/EAU/methode-prelevement-eau';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { WaterMeasure } from 'src/app/domain/EAU/water-measure';
import * as _ from 'lodash';
import { CoreData } from 'src/app/tools/core-data';
import { UntypedFormControl, Validators } from '@angular/forms';
import { WaterDialogBoxDialog } from 'src/app/tools/ui/water-measure-box/water-measure-box';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';

@Component({
    selector: 'app-eau',
    templateUrl: './eau.component.html',
    styleUrls: ['./eau.component.scss']
})
export class EauComponent implements OnInit {

    IsY2FarControl = new UntypedFormControl('', Validators.compose([
        Validators.pattern(/^(\d{7})?$/)]));
    IsX2FarControl = new UntypedFormControl('', Validators.compose([
        Validators.pattern(/^(\d{6})?$/)]));
    private MESURE_MAX = 25;
    public model: WaterProcess = new WaterProcess();

    public ModePrelevementList: string[] =
        Object.values(MethodePrelevementEau)
            .filter(x => !isNaN(Number(x)))
            .map((x: MethodePrelevementEau) => StringConverter.getMethodePrelevementEauName(x));

    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        private coreData: CoreData,
        private dialog: MatDialog,
        private waterService: WaterService,
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.save(true);
            }
        })
    }

    ngOnInit(): void {
        if (!this.route.snapshot.params.processCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        this.model.Code = this.route.snapshot.params.processCode;
        if (this.coreData.IsOffline) {
            this.model = this.coreData.getOfflineProcess(this.route.snapshot.params.processCode) as WaterProcess;
            this.orderMeasureByLength();
        } else {
            this.waterService.getProcessByCode(this.model.Code).subscribe(x => {
                this.model = x;
                this.orderMeasureByLength();
            });
        }

        this.IsX2FarControl.markAsTouched();
        this.IsY2FarControl.markAsTouched();
    }

    orderMeasureByLength() {
        if (this.model.Measures) {
            this.model.Measures = _.sortBy(this.model.Measures, [
                function (item) { return item.Distance; }
            ]);
        }
    }

    openWaterMesureBox(waterMeasure?: WaterMeasure) {
        if (this.model.Measures.length >= this.MESURE_MAX) {
            NotificationManager.handleWarning(`Le nombre maximal de mesure est de ${this.MESURE_MAX}`, this.snackBar);
            return;
        }

        const dialogRef = this.dialog.open(WaterDialogBoxDialog, {
            data: Object.assign({}, waterMeasure) ?? new WaterMeasure(),
            width: '333px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: WaterMeasure) => {
            if (result) {
                if (!waterMeasure) {
                    this.model.Measures.push(result);
                } else {
                    Object.assign(waterMeasure, result);
                }
            }
        });
    }

    removeMeasure(measure: WaterMeasure) {
        _.remove(this.model.Measures, x => x === measure);
    }
    // removeMesure() {
    //   if (this.model.Measures.length > 1) {
    //     this.model.Measures.pop();
    //   }
    // }

    canSave() {
        // if (this.model.MesureStation.LargeurStations.some(x => x.Lm === null || x.LpB === null || x.Lm === undefined || x.LpB === undefined || x.Lm === 0 || x.LpB === 0)) {
        //   return false;
        // }
        if (this.model.Measures.some(m => (m.V02P === null || m.V02P === undefined) && (m.V04P === undefined || m.V04P === null) && (m.V08P === undefined || m.V08P === null)))
            return false;

        if (this.model.Measures.some(m => (m.V02P === null || m.V02P === undefined) && (m.V04P !== undefined && m.V04P !== null) && (m.V08P !== undefined && m.V08P !== null)))
            return false;
        if (this.model.Measures.some(m => (m.V02P !== null && m.V02P !== undefined) && (m.V04P !== undefined && m.V04P !== null) && (m.V08P === undefined || m.V08P === null)))
            return false;
        if (this.model.Measures.some(m => (m.V02P !== undefined && m.V02P !== null) && (m.V04P === undefined || m.V04P === null) && (m.V08P !== undefined && m.V08P !== null)))
            return false;

        if (this.model.Measures.some(m => m.Profondeur > 15.0 && (m.V02P !== undefined && m.V02P !== null) && (m.V04P === undefined || m.V04P === null) && (m.V08P === undefined || m.V08P === null)))
            return false;
        if (this.model.Measures.some(m => m.Profondeur > 15.0 && (m.V02P === null || m.V02P === undefined) && (m.V04P !== undefined && m.V04P !== null) && (m.V08P === undefined || m.V08P === null)))
            return false;
        if (this.model.Measures.some(m => m.Profondeur > 15.0 && (m.V02P === null || m.V02P === undefined) && (m.V04P === undefined || m.V04P === null) && (m.V08P !== undefined && m.V08P !== null)))
            return false;

        return true;
    }

    save(forced: boolean) {
        if (this.canSave() || forced) {
            if (this.coreData.IsOffline) {
                this.coreData.setOfflineProcess(this.model);
                NotificationManager.handleSuccess('Intervention enregistrée', this.snackBar);
                this.orderMeasureByLength();
            } else {
                this.waterService.updateProcess(this.model).subscribe(x => {
                    this.orderMeasureByLength();
                    NotificationManager.handleSuccess('Intervention enregistrée', this.snackBar);
                });
            }
        } else {
            NotificationManager.handleWarning('Données manquantes sur certaines verticales', this.snackBar);
        }
    }

    computeWaterFlow() {
        let debitList: number[] = [];
        let i = 0;
        this.model.Measures.forEach(m => {

            let debit: number;
            let vms: number;
            let longueur: number;
            let L, L1: number;

            let v02p = m.V02P;
            let v04p = m.V04P;
            let v08p = m.V08P;

            if (v02p < 0)
                v02p = 0;
            if (v04p < 0)
                v04p = 0;
            if (v08p < 0)
                v08p = 0;

            L = i == 0 ? m.Distance : m.Distance - this.model.Measures[i - 1].Distance;
            L1 = i == this.model.Measures.length - 1 ? this.model.DistanceMesure - this.model.Measures[i].Distance : this.model.Measures[i + 1].Distance - m.Distance;
            if (v02p > 0 && v04p > 0 && v08p > 0) {
                vms = 0.5 * v04p + 0.25 * v02p + 0.25 * v08p;
            } else if (v02p > 0) {
                vms = v02p;
            } else if (v04p > 0) {
                vms = v04p;
            } else if (v08p > 0) {
                vms = v08p;
            } else {
                vms = 0;
            }

            longueur = L + L1;
            debit = vms * (m.Profondeur / 100) * longueur / 2;  // CM in METER
            debitList.push(debit);
            i++;
        });

        return _.sum(debitList);
    }
}
